/**
 * Phone tables → cards. responsive.css stacks every table into cards under
 * 600px, and each value needs its column name next to it. Rather than edit
 * every page, this copies each <th>'s text into data-label on the matching
 * <td>, for every table the app renders now or later. Cells that already
 * have a data-label (the leave tables) are left alone.
 */
function labelTable(table) {
  const heads = table.tHead && table.tHead.rows[0];
  if (!heads) return;
  const names = Array.from(heads.cells).map((th) => th.textContent.trim());
  Array.from(table.tBodies).forEach((tb) =>
    Array.from(tb.rows).forEach((tr) =>
      Array.from(tr.cells).forEach((td, i) => {
        if (!td.hasAttribute('data-label') && names[i]) td.setAttribute('data-label', names[i]);
      })
    )
  );
}

let queued = false;
function labelAll() {
  queued = false;
  document.querySelectorAll('table').forEach(labelTable);
}

export function startTableLabels() {
  if (typeof window === 'undefined' || !window.MutationObserver) return;
  labelAll();
  new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(labelAll); }
  }).observe(document.body, { childList: true, subtree: true });
}
